import { engineComponent } from "neo-common";
import { ComponentTypes } from "./ComponentTypes";

/**
 * Configuration hold elements configurations from xml by ID.
 * @class Configuration
 */
@engineComponent(ComponentTypes.Element)
export class Configuration {
    static Configurations: { [id: string]: Element } = {};
}

export const GeneralConfigurationAttributes = {
    /**
     * ReelCount is count of reels on screen for game.
     * @property ReelCount
     * @default null
     */
    REEL_COUNT: "ReelCount",
    /**
     * ReelX is array of x position for reels.
     * @property ReelX
     * @default null
     */
    REEL_X: "ReelX",
    /**
     * ReelY is array of y position for reels.
     * @property ReelY
     * @default null
     */
    REEL_Y: "ReelY",
    /**
     * Standard symbol width without offsets.
     * @property SymbolWidth
     * @default null
     */
    SYMBOL_WIDTH: "SymbolWidth",
    /**
     * Standard symbol height without offsets.
     * @property SymbolHeight
     * @default null
     */
    SYMBOL_HEIGHT: "SymbolHeight",
    /**
     * @property SymbolBottomCount
     */
    SYMBOL_BOTTOM_COUNT: "SymbolBottomCount",
    /**
     *@property SymbolTopCount
     */
    SYMBOL_TOP_COUNT: "SymbolTopCount",
    /**
     * Number of symbols visible on reel.
     * @property VisibleSymbolCount
     * @default null
     */
    VISIBLE_SYMBOL_COUNT: "VisibleSymbolCount",
    /**
     * Wins multipliers (need WinsAnimations with same array length).
     * @property WinsMultipliers
     * @default null
     */
    WINS_MULTIPLIERS: "WinsMultipliers",
    /**
     * Wins animations (need WinsMultipliers with same array length).
     * @property WinsAnimations
     * @default null
     */
    WINS_ANIMATIONS: "WinsAnimations",
};

export const ReelConfigurationAttributes = {
    /**
     * ForceSpeed of rotation in frames.
     * @property ForceSpeed
     * @default 3
     */
    FORCE_SPEED: "ForceSpeed",
    /**
     * Multiplier for force speed.
     * @property ForceSpeedMultipler
     * @default 1.5
     */
    FORCE_SPEED_MULTIPLER: "ForceSpeedMultipler",
    /**
     * Pre roll height in pixels.
     * @property PreRoll
     * @default 180
     */
    PRE_ROLL: "PreRoll",
    /**
     * Pre roll speed in frames.
     * @property PreRollSpeed
     * @default 10
     */
    PRE_ROLL_SPEED: "PreRollSpeed",
    /**
     * Post roll height in pixels.
     * @property PostRoll
     * @default 180
     */
    POST_ROLL: "PostRoll",
    /**
     * Post roll speed in frames.
     * @property PostRollSpeed
     * @default 5
     */
    POST_ROLL_SPEED: "PostRollSpeed",
    /**
     * Speed of rotation in frames.
     * @property Speed
     * @default 3
     */
    SPEED: "Speed",
};

export const MachineConfigurationAttributes = {
    /**
     * Min spin rotation in frames.
     * @property MinSpinRotation
     * @default 40
     */
    MIN_SPIN_ROTATION: "MinSpinRotation",
    /**
     * Min spin rotation in frames for outro high wins.
     * @property MinSpinRotationLong
     * @default 100
     */
    MIN_SPIN_ROTATION_LONG: "MinSpinRotationLong",
    /**
     * Delay to start rotation in frames.
     * @property StartDelay
     * @default 3
     */
    START_DELAY: "StartDelay",
    /**
     * Delay to stop rotation in frames.
     * @property StopDelay
     * @default 10
     */
    STOP_DELAY: "StopDelay",
    /**
     * Configuration ID for reels.
     * @property StopDelay
     * @type string
     * @default null
     */
    REEL_CONFIGURATION: "ReelConfiguration",
    /**
     * Teasings defined array of symbols which will go after reel stopped to teaser state.
     * @property Teasings
     * @default null
     *
     * @deprecated Use TeasingSymbols istead Teasing
     */
    TEASINGS: "Teasings",
    /**
     * Teasings defined array of symbols which will go after reel stopped to teaser state.
     * @property Teasings
     * @default null
     */
    TEASING_SYMBOLS: "TeasingSymbols",
    /**
     *
     */
    TEASING_STOP_DELAY: "TeasingStopDelay",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Configuration.ts
 **/